<template>
  <Flex v-bind="$attrs" class="flex-col">
    <slot></slot>
  </Flex>
</template>

<script></script>

<style></style>
